import { Component, OnInit } from '@angular/core';
import { clearGisAuthRetryCounter } from '@app/modules/gis/gis-token';
import { GIS_PORTAL_BASE } from '@app/modules/gis/gis-config';

@Component({
  selector: 'app-gis-auth-error',
  templateUrl: './gis-auth-error.component.html',
  styleUrls: ['./gis-auth-error.component.scss']
})
export class GisAuthErrorComponent implements OnInit {
  portalUrl = GIS_PORTAL_BASE;
  supportEmail = 'GSC-EMIT-UIT-DISCOVERY-ASSESSMENT@exxonmobil.com';

  constructor() {}

  ngOnInit() {}

  /**
   * Clear retry counter then do a full page reload to /geobrain.
   * Full reload is required so the guard runs fresh after state is cleared —
   * Angular router.navigate() fires the guard in the same page load without
   * clearing token state, causing an immediate loop back to this page.
   */
  retryAuthentication() {
    clearGisAuthRetryCounter();
    window.location.href = '/geobrain';
  }
}
